// ═══════════════════════════════════════════════════════════════
// V·IANet Governance — Process Map Design System
// Paleta corporativa + tokens de diseño para el módulo
// ═══════════════════════════════════════════════════════════════

export const PM = {
  // Colores corporativos VALOR·IA
  azul1: '#1F3864',
  azul2: '#2F5496',
  azulMuyOscuro: '#0E243E',
  azulOscuro: '#16365B',
  azulMedio: '#16507D',
  azulClaro: '#1A94BF',
  celeste: '#33BCE1',
  acento: '#4472C4',
  azulSuave: '#D6E4F0',
  acentoSuave: '#E8EFF9',

  // Superficies
  bg: '#F7F8FA',
  surface: '#FFFFFF',
  border: '#E5E7EB',
  borderAlt: '#F0F0F0',

  // Texto
  text: '#1E293B',
  textSec: '#64748B',
  textMut: '#94A3B8',

  // Funcionales
  verdeOk: '#16A34A',
  rojoError: '#DC2626',
  ambar: '#F59E0B',

  // Gradientes
  gradientDark: 'linear-gradient(135deg, #0E243E 0%, #1F3864 100%)',
  gradientCorp: 'linear-gradient(135deg, #1F3864 0%, #16507D 50%, #33BCE1 100%)',

  // Tarjetas (estilo relieve)
  card: {
    borderRadius: 14,
    shadow: '0 2px 8px rgba(31, 56, 100, 0.08)',
    shadowHover: '0 8px 24px rgba(31, 56, 100, 0.14)',
    border: '1px solid #E5E7EB',
    transition: 'box-shadow 0.25s ease, transform 0.25s ease',
  },

  // Colores por grupo de procesos
  // Orbital layout (Level 1 redesign)
  orbital: {
    containerHeight: 650,
    centerSize: 500,
    centerOpacity: 0.03,
    peRadius: 180,
    psRadius: 200,
    iconSizePE: 56,
    iconSizePO: 72,
    iconSizePS: 56,
    poLineColor: 'rgba(51,188,225,0.25)',
    orbitStroke: 'rgba(31,56,100,0.04)',
    bandLabelColor: '#C8C8C8',
  },

  grupoColors: {
    1: '#1F3864', // Gobierno y Estrategia
    2: '#1F3864', // Desarrollo de Negocio
    3: '#1A94BF', // Ingeniería Organizativa
    4: '#2F5496', // Ingeniería de Procesos
    5: '#4472C4', // Ingeniería de la Información
    6: '#16507D', // Ingeniería de Cumplimiento
    7: '#33BCE1', // Ingeniería Tecnológica
    8: '#0E243E', // Ingeniería Reputacional
    9: '#16365B', // Personas
    10: '#16365B', // Finanzas
    11: '#16365B', // Tecnología
    12: '#16365B', // Calidad y Mejora
  } as Record<number, string>,
} as const;
